import styled from 'styled-components';
import {BGImageCenter, dFlex} from '../../../../globalVariables/GlobalVariables';
import {text, container} from '../../../../component/modeBtn/ModeBtn.css';
import { getPrimitive, getSpacing } from '@tickchak/react-share/app';
import { popUpBody } from '../../../../component/newPopup/mobilePopup/MobilePopup.css';
import { justifyEnd } from '../../../../globalVariables/GlobalFlex';
import zIndex from '../../../../globalVariables/zIndex';

export const wrapper = styled.div`
    position: relative;
    ${container} {
        width: 50px;
        ${justifyEnd};
        ${text} {
            margin-inline-end: -40px;
            &.active {
                color: ${getPrimitive('solids.black')};
                z-index: ${zIndex.baseRaised};
                margin-inline-end: -25px;
            }
        }
    }
    ${popUpBody}{
        height: 100%;
    }
    fieldset {
        border: none;
    }
`;
export const stepIcon = styled.div<{icon: string}>`
    width: 21px;
    height: 21px;
    ${p => BGImageCenter(p.icon, '12px')}
`;

export const headerItems = styled.div`
    gap: ${getSpacing('spaceSm')};
    ${dFlex};
`;